<template>
  <div class="container">
      <!-- Test starts-->

    <!--BUTTON ROW START-->
    <div class="row myMenu">
      <div class="col">
        <div class="row menuBtn" >
            <div class="col-3">
                <img alt="about" v-on:click="toggleClick('about')" v-on:mouseover="mouveOverIMG('about')" v-on:mouseleave="mouveLeaveIMG('about')" :src="aboutsrc">
            </div>
            <div class="col-4">
              <img alt="interactive" v-on:click="toggleClick('interactive')" v-on:mouseover="mouveOverIMG('interactive')" v-on:mouseleave="mouveLeaveIMG('interactive')" :src="interactivesrc">
                <!--<p v-on:click="toggleClick('Interactive')">INTERACTIVE</p>-->
                <!--<img alt="comics" v-on:click="toggleClick('comics')" v-on:mouseover="mouveOverIMG('comics')" v-on:mouseleave="mouveLeaveIMG('comics')" src="../assets/main/comics/comic_buttons3.png">-->
            </div>
            <div class="col-2">
              <img alt="art" v-on:click="toggleClick('art')" v-on:mouseover="mouveOverIMG('art')" v-on:mouseleave="mouveLeaveIMG('art')" :src="artsrc">
                <!--<p v-on:click="toggleClick('Tools')">TOOLS</p>-->
                <!--<img alt="shop" v-on:click="toggleClick('shop')" v-on:mouseover="mouveOverIMG('shop')" v-on:mouseleave="mouveLeaveIMG('shop')" src="../assets/main/comics/comic_buttons3.png">-->
            </div>
            <div class="col-3">
              <img alt="tools" v-on:click="toggleClick('tools')" v-on:mouseover="mouveOverIMG('tools')" v-on:mouseleave="mouveLeaveIMG('tools')" :src="toolssrc">
                <!--<p v-on:click="toggleClick('Visual')">VISUAL</p>-->
                <!--<img alt="shop" v-on:click="toggleClick('shop')" v-on:mouseover="mouveOverIMG('shop')" v-on:mouseleave="mouveLeaveIMG('shop')" src="../assets/main/comics/comic_buttons3.png">-->
            </div>
        </div>
      </div>
    </div>
    <!--BUTTON ROW END-->
    <span class="myMenu">
        <img class="myMenu" alt="menu" src="@/assets/main/menu.png">
    </span>
    
    <div class="container">
        <div class="row displayContainer">
        <div class="col">
            <div v-if="selected == 'about'">
                <About v-bind="$props"></About>
            </div>
            <div v-else-if="selected == 'interactive'">
                <Interactive></Interactive>
            </div>
            <div v-else-if="selected == 'art'">
                <Visual></Visual>
            </div>
          <div v-else-if="selected == 'tools'">
                <Tools></Tools>
            </div>
        </div>
        <!-- Test end-->
        </div>
    </div>

  </div>
</template>

<script>
import About from './About'
import Interactive from './Interactive'
import Tools from './Tools'
import Visual from './Visual'

export default {
  name: 'Main',
  props: ['cookieStatus'],
  data: () => ({
    cookieStatus: "",
    selected: "about",
    aboutsrc:  require("@/assets/main/about/about_buttons3.png"),
    interactivesrc:  require("@/assets/main/interactive/interactive_buttons1.png"),
    artsrc:  require("@/assets/main/art/art_buttons1.png"),
    toolssrc:  require("@/assets/main/tools/tools_buttons1.png"),
    about: [
      {
        notClicked: require("@/assets/main/about/about_buttons1.png")
        },
      {
        hover: require("@/assets/main/about/about_buttons2.png")
        }, 
      {
        clicked: require("@/assets/main/about/about_buttons3.png")
      }],
    interactive: [
      {
        notClicked: require("@/assets/main/interactive/interactive_buttons1.png")
        },
      {
        hover: require("@/assets/main/interactive/interactive_buttons2.png")
        }, 
      {
        clicked: require("@/assets/main/interactive/interactive_buttons3.png")
      }],
    art: [
      {
        notClicked: require("@/assets/main/art/art_buttons1.png")
        },
      {
        hover: require("@/assets/main/art/art_buttons2.png")
        }, 
      {
        clicked: require("@/assets/main/art/art_buttons3.png")
      }],
    tools: [
      {
        notClicked: require("@/assets/main/tools/tools_buttons1.png")
        },
      {
        hover: require("@/assets/main/tools/tools_buttons2.png")
        }, 
      {
        clicked: require("@/assets/main/tools/tools_buttons3.png")
      }]
  }),
  components:{
    'About' : About,
    'Interactive' : Interactive,
    'Tools' : Tools,
    'Visual': Visual
  },
  methods:{
    setCookieStatus(){
      this.cookieStatus = this.myCookieStatus
    },
    toggleClick(myName){
        //deselect everyting
        this.deselectEverything();

        // Set selected component to display
        this.selected = myName;

        if(myName == "about"){
          this.aboutsrc = this.about[2].clicked;
        }else if(myName == "interactive"){
          this.interactivesrc = this.interactive[2].clicked;
        }else if(myName == "art"){
          this.artsrc = this.art[2].clicked;
        }else if(myName == "tools"){
          this.toolssrc = this.tools[2].clicked;
        }
    },
    mouveOverIMG(myName){
      
      // Set source image
      if( myName == "about" && this.selected != "about"){
        this.aboutsrc = this.about[1].hover;
      }else if (myName == "interactive" && this.selected != "interactive"){
        this.interactivesrc = this.interactive[1].hover;
      }else if (myName == "art" && this.selected != "art"){
        this.artsrc = this.art[1].hover;
      }else if (myName == "tools" && this.selected != "tools"){
        this.toolssrc = this.tools[1].hover;
      }

    },
    mouveLeaveIMG(myName){

      // Set source image
      if( myName == "about" && myName != this.selected){
        this.aboutsrc = this.about[0].notClicked;
      }else if (myName == "interactive" && myName != this.selected){
        this.interactivesrc = this.interactive[0].notClicked;
      }else if (myName == "art" && myName != this.selected){
        this.artsrc = this.art[0].notClicked;
      }else if (myName == "tools" && myName != this.selected){
        this.toolssrc = this.tools[0].notClicked;
      }
    },
    deselectEverything(){
        this.aboutsrc = this.about[0].notClicked;
        this.interactivesrc = this.interactive[0].notClicked;
        this.artsrc = this.art[0].notClicked;
        this.toolssrc = this.tools[0].notClicked;
      }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.myMenu{
    min-width: 386px;
    z-index: 1;
    display: block;
    margin-left: auto;  
    margin-right: auto;
    
}
.container{
    max-width: 900px;
    min-width: 900px;
}
.displayContainer{
  padding:0 1% 0 1%;
  
}
.buttons{
  padding-top: 2%;
  z-index: 2;
  position:absolute;
  text-align: center;
}
.menuBtn{
    position:absolute;
    padding-left:10%;
    padding-right:10%;
    padding-top:1.5%;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
p {
  color: #ffffff;
}

</style>
